import { getTenantidFromIdToken } from 'utils/utils';

// CRA inlines REACT_APP_* only when referenced literally, so each list is
// named explicitly. Local stages reuse the list of the backend they call.
const tenantListForStage = (stage: string | undefined): string | undefined => {
  switch (stage) {
    case 'dev':
    case 'devLocal':
      return process.env.REACT_APP_SEMANTIC_SEARCH_TENANTS_DEV;
    case 'stage':
    case 'stageLocal':
      return process.env.REACT_APP_SEMANTIC_SEARCH_TENANTS_STAGE;
    case 'prod':
      return process.env.REACT_APP_SEMANTIC_SEARCH_TENANTS_PROD;
    default:
      return undefined;
  }
};

const ALL_TENANTS = 'all';

/** Semantic search is set per tenant: a tenant listed for the stage this
 * build targets, or every tenant when the list contains `all`, searches
 * content items with semantic only. Others keep the normal library. Unknown
 * stage or empty list means no tenant uses semantic. */
export const isSemanticSearchAllowed = (
  tenantId: string | null = getTenantidFromIdToken(),
  stage: string | undefined = process.env.REACT_APP_STAGE,
): boolean => {
  if (!tenantId) return false;

  const allowed = (tenantListForStage(stage) ?? '')
    .split(',')
    .map((id) => id.trim().toLowerCase())
    .filter(Boolean);

  return (
    allowed.includes(ALL_TENANTS) || allowed.includes(tenantId.toLowerCase())
  );
};
